export default "__VITE_ASSET__LvpIVV0i__"